import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * AuthCallback — invoked when URL contains #session_id=...
 * Exchanges the session_id with backend, then redirects to /dashboard.
 */
export default function AuthCallback() {
  const { exchangeSessionId } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);

    (async () => {
      try {
        const user = await exchangeSessionId(sid);
        // Strip the hash and go to dashboard with user state
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed. Please try again.");
      }
    })();
  }, [exchangeSessionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-note-red font-medium mb-3">{error}</p>
            <button
              onClick={() => navigate("/login")}
              className="text-accent underline"
            >
              Back to sign-in
            </button>
          </>
        ) : (
          <p className="text-ink-3" style={{ fontSize: 13 }}>
            Signing you in…
          </p>
        )}
      </div>
    </div>
  );
}
